module.exports = __webpack_public_path__ + "img/broward-medical-examiners-sheriff-facility-1.c2e26c92.jpg";